import { useTranslation } from 'react-i18next';
import StandardModal, { ModalButtonType } from '../../Fundamentals/Modal/StandardModal';

/**
 * @deprecated This component should be replaced with <ConfirmModal> - Niels-Oliver Eriksson
 */

const RepublishEventModal = ({ title, description, onConfirm, isLoading = false }) => {
    const { t } = useTranslation();

    const modalTitle = title || t('republishEventModal.title');
    const modalDescription = description || t('republishEventModal.description');

    return (
        <StandardModal
            title={modalTitle}
            type={ModalButtonType.SEND}
            onSubmit={onConfirm}
            isLoading={isLoading}
        >
            <p>{modalDescription}</p>
        </StandardModal>
    );
};

export default RepublishEventModal;